module.exports = __webpack_public_path__ + "img/2024-09-19b_5.2d97bbc9.jpg";